import { render, staticRenderFns } from "./firstBg.vue?vue&type=template&id=f562b426&scoped=true&"
import script from "./firstBg.vue?vue&type=script&lang=ts&"
export * from "./firstBg.vue?vue&type=script&lang=ts&"
import style0 from "./firstBg.vue?vue&type=style&index=0&id=f562b426&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f562b426",
  null
  
)

export default component.exports